"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMilestoneActivityTranslation = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const useMilestoneActivityTranslation = () => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const getMilestoneActivityTranslation = (milestone, activityCustomField) => {
        const actual = activityCustomField?.['actual'];
        const confirmed = activityCustomField?.['confirmed'];
        const term = actual
            ? `activity-feed_transport-plan-update_${milestone}-completed`
            : `activity-feed_transport-plan-update_new-date-${milestone}`;
        let statusTerm = 'activity-feed_transport-plan-update_estimated';
        if (actual) {
            statusTerm = '';
        }
        if (confirmed) {
            statusTerm = 'activity-feed_transport-plan-update_confirmed';
        }
        return translate(term) + (statusTerm && ` [${translate(statusTerm)}]`);
    };
    return { getMilestoneActivityTranslation };
};
exports.useMilestoneActivityTranslation = useMilestoneActivityTranslation;
//# sourceMappingURL=useMilestoneActivityTranslation.js.map